import React from 'react';
import PropTypes from 'prop-types';
import {_truncateDomainName} from "../../common/helpers/HelperFunc";


import Button from "../../common/primitives/Button";
import Label from "../../common/primitives/Label";
import SelectPrice from "../../common/primitives/SelectPrice";

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from './img/remove.png';
import styles from "./CartLines.scss";
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import HelperGoogleAnalytics4 from "../../common/helpers/HelperGoogleAnalytics4";
import Price, {ConvertToEUR} from "../../common/primitives/Price";
import LoadingRow from "../../common/primitives/LoadingRow";
import {__t} from '../../common/lang/text-resource';

const CartLineDomain = ({
							data,
							taxonomy,
							removeService,
							changeServiceTerm,
							showDomainContactData,
							showAsPage,
							childServices
						}) => {
	const {
		id,
		serviceName,
		serviceId,
		priceData,
		servicePriceId,
		discountPriceList,
		discountPromo,
		discountTerm,
		hasContactData,
		contactDataMainName,
		isCyrillic,
		domainTLD,
		isNewService,
		isRenewService,
		currency,
		canDelete,
		loading,
		term,
		priceOrig,
		priceTopOrig,
		is_contact_data_valid,
		showPriceSelector
	} = data;
	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div
				data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}

	const showSecondRow = (hasContactData || discountPriceList > 0 || discountPromo > 0 || discountTerm > 0) && serviceId !== 'existing_domain_01';
	const hasDomainError = hasContactData && showAsPage && isNewService && is_contact_data_valid === false;

	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDelete === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt={__t("Remove")}/>
					</button>
				  }
			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={_truncateDomainName(serviceName, domainTLD, 24)}
					title={serviceName}
					className={`${helpers.orderServiceName} ${!showAsPage ? styles.asPageServiceName : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
			  <div data-layout={`col 11 margin-top--xs padding-left--xs ${showAsPage ? '6@md' : ''}`}>
				  {
					  (showPriceSelector === true && showAsPage === true && serviceId !== 'existing_domain_01') ?
						<SelectPrice
						  name={id}
						  newPriceCol="price"
						  valueCol="priceId"
						  labelCol="term"
						  options={priceData}
						  oldPriceCol="oldPrice"
						  currencyCol="currency"
						  selected={servicePriceId}
						  onChange={changeServiceTerm}
						  onMenuOpen={() => {
							  HelperGoogleAnalytics.TrackServicePriceSelectorOpen(taxonomy, isNewService);
							  HelperGoogleAnalytics4.TrackServicePriceSelectorOpen(taxonomy, isNewService);
						  }}/>
						:
						<table className={styles.selectedPriceContainer}>
							<tbody>
							<tr>
								<td>{term}</td>
								<td className={styles.oldPrice}>
									{
										priceTopOrig !== priceOrig ? priceTopOrig : null
									}
									{SHVO.showEuroPrices && <>
										<br/>
										{
											priceTopOrig !== priceOrig ? ConvertToEUR(priceTopOrig) : null
										}
									</>}
								</td>
								<td>
									<Price
									  currency={currency}
									  value={priceOrig}
									  currencyClass={styles.currency}/>
									{SHVO.showEuroPrices && <>
										<br/>
										<Price
										  currency={'EUR'}
										  value={ConvertToEUR(priceOrig)}
										  currencyClass={styles.currency}/>
									</>}
								</td>
								<td data-layout='padding-right--md'>&nbsp;</td>
							</tr>
							</tbody>
						</table>
				  }
			  </div>
		  </div>
		  {
			  showSecondRow ?
				<div data-layout="row gutter-none start" className={styles.discountsWrapper}>
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*Редове с отстъпки начало*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					<div className={styles.rightAtTabPage} data-layout={`col 12 ${showAsPage ? '6@md' : ''}`}>

						{
							(discountPriceList > 0 && discountPromo < 100) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {__t('–-discountPriceList%-допълнителна-партньорска-отс74ed8e', {discountPriceList: discountPriceList})}
								  </div>
							  </div>
							  : ''
						}

						{
							(discountPromo > 0) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {__t('–:discountPromo% отстъпка от промокод', {discountPromo: discountPromo})}
								  </div>
							  </div>
							  : ''
						}

						{
							(discountTerm > 0 && discountPromo < 100) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs  padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {isRenewService ? __t('-:discount% промоционална отстъпка', {discount: discountTerm}) : __t('-:discount% отстъпка за нова услуга', {discount: discountTerm})}
								  </div>
							  </div>
							  : ''
						}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Редове с отстъпки край*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					</div>
					{
						showAsPage ? <div className={styles.removeContainer} data-layout="first@md"/> : ''
					}
					<div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}>
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Данни за собственик*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{
							(hasContactData && showAsPage && isNewService) ?
							  <div data-layout="row gutter-none middle margin-top--xxs">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									className={styles.whNWTab}
									data-layout="col 11 margin-top--xs  padding-left--xs text-left">
									  {__t('Регистрант:')}&nbsp;
									  <Button
										name={'whois_01'}
										value={contactDataMainName}
										className={`${buttons.buttonLink} ${buttons.action} ${styles.contactDataButton}`}
										onClick={() => showDomainContactData(id)}
										testId={`domain-contact-data-button-${serviceName}`}/>
								  </div>
							  </div>
							  : ''
						}
						{
						  (hasDomainError) &&
						  <div data-layout="row gutter-none middle margin-top--xxs">
							  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							  <div
								className={styles.whNWTab}
								data-layout="col 11 margin-top--xs  padding-left--xs text-left">
								  <Button
									name={'eu_domain_error'}
									value={__t("Невалидни контактни данни")}
									className={`${buttons.buttonLink} ${buttons.action} ${styles.euDomainErrorButton}`}
									onClick={() => showDomainContactData(id)}
									testId={`domain-contact-data-error-button-${serviceName}`}/>
							  </div>
						  </div>
						}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Данни за собственик край*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					</div>
				</div>
				: ''
		  }
		  {
			(serviceId !== 'existing_domain_01') &&
			<div data-layout="row gutter-none start">
				{
					showAsPage ? <div className={styles.removeContainer} data-layout="first@md"/> : ''
				}
				<div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}>
					<div data-layout="row gutter-none middle margin-top--xxs">
						<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
						<div data-layout="col 11 margin-top--xs  padding-left--xs text-left">
							{isRenewService ? __t('Подновяване  на домейн') : __t('Регистрация на домейн')}
						</div>
					</div>
				</div>
			</div>
		  }
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги начало*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {
			  (childServices) ?
				childServices.map((child, i) => {
					return (
					  <div key={i} data-layout="row gutter-none middle margin-top--xxs">
						  <div className={styles.removeContainer}
							   data-layout={!showAsPage ? 'padding-left--xs col 1' : ''}/>
						  <div
							className={styles.childServiceContainer}
							data-layout={`col 11 margin-top--smm padding-left--xs text-left ${showAsPage ? '5@md' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td>
										  {child.serviceTypeName}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>
						  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
						  <div
							className={styles.childServiceContainerPrice}
							data-layout={`col 11 margin-top--xs padding-left--xs text-left ${showAsPage ? '6@md' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td>
										  {term}
									  </td>
									  <td className={styles.oldPrice}>
										  {
											  child.priceOrig !== child.priceTopOrig ? child.priceTopOrig : null
										  }
										  {SHVO.showEuroPrices && <>
											  <br/>
											  {
												  child.priceOrig !== child.priceTopOrig ? ConvertToEUR(child.priceTopOrig) : null
											  }
										  </>}
									  </td>
									  <td>
										  <Price
											currency={child.currency}
											value={child.price}/>
										  {SHVO.showEuroPrices && <>
											  <br/>
											  <Price
												currency={'EUR'}
												value={ConvertToEUR(child.price)}/>
										  </>}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>

						  {
							  (child.percentOff > 0) ?
								<div data-layout="col 12">
									<div data-layout="row gutter-none middle" className={styles.vpsDiscounts}>
										<div
										  data-layout="col 11 offset-1 margin-top--xs padding-left--xs text-left margin-right--20"
										  className={helpers.orderServiceDiscount}>
											{__t('–:percentOff% отстъпка', {percentOff: child.percentOff})}
										</div>
									</div>
								</div>
								: ''
						  }
					  </div>
					)
				})

				: undefined
		  }
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги край*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

	  </section>
	);

};
CartLineDomain.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceType: PropTypes.string.isRequired,
		isNewService: PropTypes.bool,
		isRenewService: PropTypes.bool,
		hasContactData: PropTypes.bool,
		contactDataMainName: PropTypes.string,
		isCyrillic: PropTypes.bool,
		canDelete: PropTypes.bool,
		domainTLD: PropTypes.string,
		servicePriceId: PropTypes.string,
		discountPriceList: PropTypes.number,
		discountPromo: PropTypes.number,
		discountTerm: PropTypes.number,
		currency: PropTypes.string,
		priceData: PropTypes.arrayOf(
		  PropTypes.shape({
			  currency: PropTypes.string,
			  oldPrice: PropTypes.string,
			  price: PropTypes.string,
			  priceId: PropTypes.string,
			  term: PropTypes.string,
		  })
		)
	}),
	taxonomy: PropTypes.object,
	removeService: PropTypes.func.isRequired,
	changeServiceTerm: PropTypes.func.isRequired,
	showDomainContactData: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool,
	childServices: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
		quantity: PropTypes.string,
		serviceType: PropTypes.string,
		currency: PropTypes.string,
		price: PropTypes.string,
	})]),
};

export default CartLineDomain;